module.exports = __webpack_public_path__ + "assets/img/step7.8146a44d.png";